export default "__VITE_ASSET__CRzPd5fj__"